// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1siUh","colCheckbox":"styles_colCheckbox__FtfXw"};